
<template>
  <div id="parentx-demo-2">
    <vs-sidebar
      v-if="convId"
      :parent="`#${conversationType}-app`"
      position-right
      :hidden-background="false"
      v-model="activeLocal"
      id="chat-profile-sidebar"
      class="items-no-padding"
    >
      <div class="header-sidebar relative flex flex-col p-0" slot="header">
        <feather-icon
          icon="XIcon"
          svgClasses="m-2 cursor-pointer absolute top-0 right-0"
          @click="$emit('closeProfileSidebar', false)"
        ></feather-icon>

        <div v-if="conversationType == 'chat'" class="flex flex-col items-center">
          <div class="relative inline-flex mx-auto mb-5 mt-6">
            <vs-avatar
              class="m-0 border-white border-2 border-solid shadow-md"
              :src="conversation.messengerUser.profilePic"
              size="70px"
            />
          </div>

          <h4 class="mr-2 self-center">
            {{ conversation.messengerUser.firstName + " " + conversation.messengerUser.lastName }}
          </h4>
        </div>
        <div v-else class="flex flex-col items-center py-4">
          <h4>
            {{ conversation.guestEmailName }}
          </h4>
          <h6 class="mt-2 text-grey">
            {{ conversation.guestEmail }}
          </h6>
        </div>
      </div>

      <component :is="scrollbarTag" class="scroll-area" :settings="settings" :key="$vs.rtl">
        <div class="p-8 flex flex-col">
          <vs-button
            v-if="attachedGuestProfile && !selectGuest"
            class="px-2 w-full"
            type="flat"
            color="danger"
            @click.stop="detachGust"
            >Detach guest from conversation
          </vs-button>
          <vs-button
            v-if="attachedGuestProfile && !selectGuest"
            class="mb-3 px-2 w-full"
            type="flat"
            color="danger"
            @click.stop="selectGuest = true"
            >Attach to other guest
          </vs-button>
          <vs-button
            v-if="attachedGuestProfile && selectGuest"
            class="mb-3 px-2 w-full"
            type="flat"
            @click.stop="selectGuest = false"
            >Back
          </vs-button>

          <div v-if="selectGuest">
            <span v-if="!conversation.guestId">
              <span v-if="conversationType == 'chat'"
                >Messenger guest is not paired with a CRM profile. Find a CRM guest profile to attach:</span
              >
              <span v-if="conversationType == 'email'"
                >Email guest is not paired with a CRM profile. Find a CRM guest profile to attach:</span
              >
            </span>
            <span v-else> Already paired with a CRM profile. Select a new CRM guest profile to change: </span>

            <div class="flex mt-2">
              <vs-input
                v-model="guestSearchQuery"
                class="flex-grow mr-2"
                v-on:keyup.enter="onSearch"
              ></vs-input>
              <vs-button @click="onSearch" radius icon="search"></vs-button>
            </div>

            <vs-list class="mb-2" v-if="!isSearching">
              <span v-if="guestProfiles.length == 0">No results</span>
              <vs-list-item
                v-for="guest in guestProfiles"
                :key="guest.id"
                :title="guest.firstName + ' ' + guest.lastName"
                :subtitle="guest.email + ' ' + guest.phone"
              >
                <vs-button size="small" class="px-4" @click.stop="attachGuest(guest)">Pick</vs-button>
              </vs-list-item>
            </vs-list>

            <div v-else class="self-center mt-2">Searching...</div>
          </div>

          <div v-if="attachedGuestProfile && !selectGuest" class="flex flex-col">
            <h6 class="mt-2 mb-3">Guest info</h6>
            <div class="flex">
              <feather-icon icon="UserIcon" svgClasses="w-4 h-4'"></feather-icon>
              <span class="ml-2">{{
                attachedGuestProfile.firstName + " " + attachedGuestProfile.lastName
              }}</span>
            </div>
            <div class="flex">
              <feather-icon icon="MailIcon" svgClasses="w-4 h-4'"></feather-icon>
              <span class="ml-2">{{ attachedGuestProfile.email }}</span>
            </div>
            <div class="flex">
              <feather-icon icon="PhoneIcon" svgClasses="w-4 h-4'"></feather-icon>
              <span class="ml-2">{{ attachedGuestProfile.phone }}</span>
            </div>
            <div class="flex">
              <feather-icon icon="GiftIcon" svgClasses="w-4 h-4'"></feather-icon>
              <span v-if="attachedGuestProfile.hasSetBirthday" class="ml-2">{{
                attachedGuestProfile.birthDate | date
              }}</span>
            </div>

            <div class="flex">
              <vs-chip :key="idx" v-for="(tag, idx) in attachedGuestProfile.labels" class="mr-1">
                {{ tag.value }}
              </vs-chip>
            </div>

            <h6 class="mt-6 mb-2">Guest notes</h6>
            <vs-row class="mb-3">
              <vs-input
                class="guest-note-chat-textarea flex-grow"
                v-model="newGuestNote"
                placeholder="Type a note to add to the guest..."
              ></vs-input>
              <vs-button class="px-4 ml-2" :disabled="newGuestNote == ''" @click.stop="addGuestNote"
                >Add</vs-button
              >
            </vs-row>
            <div class="flex flex-col-reverse">
              <vs-card v-for="(note, idx) in attachedGuestProfile.noteList" :key="idx">
                <div class="text-base">{{ note.note }}</div>
                <div slot="footer" class="flex justify-end">
                  <span class="text-sm text-grey"
                    >{{ note.addedAction.userDisplayName }} @ {{ note.addedAction.timestamp | date }}</span
                  >
                </div>
              </vs-card>
            </div>
          </div>
        </div>
      </component>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { mapGetters } from "vuex";

export default {
  props: {
    convId: {
      type: String | null,
      required: true,
    },
    active: {
      type: Boolean,
      required: true,
    },
    conversationType: {
      type: String,
      required: true,
    },
    defaultSearchQuery: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      counterDanger: false,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      guestSearchQuery: "",
      attachedGuestProfile: null,
      selectGuest: false,
      isEditing: false,
      newGuestNote: "",
    };
  },
  watch: {
    async convId() {
      this.attachedGuestProfile = null;
      if (this.conversation) {
        if (this.conversation.guestId) {
          await this.$store.dispatch("guestProfiles/getGuest", this.conversation.guestId);
          this.attachedGuestProfile = this.$store.getters["guestProfiles/profile"](this.conversation.guestId);
        } else {
          this.guestSearchQuery = this.defaultSearchQuery;
          this.onSearch();
        }
      }
      this.selectGuest = !this.attachedGuestProfile;
    },
    async active(newValue) {
      // If just opened sidebar
      if (newValue) {
        // And guest is attached. Get newest profile info
        if (this.conversation.guestId) {
          await this.$store.dispatch("guestProfiles/getGuest", this.conversation.guestId);
          this.attachedGuestProfile = this.$store.getters["guestProfiles/profile"](this.conversation.guestId);
        }
        // And no guest attached. Perform search
        else {
          this.guestSearchQuery = this.defaultSearchQuery;
          this.onSearch();
        }
      }
    },
  },
  methods: {
    async addGuestNote() {
      this.$vs.loading();
      try {
        console.log("adding guest note profile", this.newGuestNote);
        await this.$store.dispatch("guestProfiles/addGuestNote", {
          guestId: this.attachedGuestProfile.id,
          note: this.newGuestNote,
        });

        this.$vs.notify({
          color: "green",
          title: "Saved",
          text: "Guest note saved",
        });
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Could not be saved",
          text: "Could not be saved",
        });
      } finally {
        this.newGuestNote = "";
        this.attachedGuestProfile = this.$store.getters["guestProfiles/profile"](this.conversation.guestId);
        this.$vs.loading.close();
      }
    },

    async detachGust() {
      this.$vs.loading();
      try {
        await this.$store.dispatch(`${this.conversationType}/detachGuest`, {
          conversationId: this.convId,
        });

        this.conversation.guestId = null;
        this.selectGuest = true;

        this.$vs.notify({
          color: "green",
          title: "Detached",
          text: "Guest detached",
        });
      } catch (err) {
        console.error(err);
        this.$vs.notify({
          color: "danger",
          title: "Could not be detached",
          text: "Could not be detached",
        });
      } finally {
        this.attachedGuestProfile = null;
        this.$vs.loading.close();
      }
    },

    async attachGuest(guest) {
      this.$vs.loading();
      try {
        console.log("Attaching guest profile", guest);
        await this.$store.dispatch(`${this.conversationType}/attachGuest`, {
          conversationId: this.convId,
          guestProfileId: guest.id,
        });
        await this.$store.dispatch("guestProfiles/getGuest", guest.id);
        this.selectGuest = false;
        this.attachedGuestProfile = null; // To enforce change, even for same guest
        this.attachedGuestProfile = this.$store.getters["guestProfiles/profile"](guest.id);

        this.$vs.notify({
          color: "green",
          title: "Success",
          text: "Guest attached",
        });
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Could not attach guest",
          text: "Could not attach guest",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async onSearch() {
      await this.$store.dispatch("guestProfiles/queryGuests", this.guestSearchQuery);
    },
  },
  computed: {
    ...mapGetters({
      guestProfiles: "guestProfiles/queryResult",
      isSearching: "guestProfiles/isSearching",
    }),

    conversation() {
      return this.$store.getters[`${this.conversationType}/conversation`](this.convId);
    },
    activeLocal: {
      get() {
        console.log("IS ACTIVE?", this.active);
        return this.active;
      },
      set(value) {
        this.$emit("closeProfileSidebar", value);
      },
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  components: {
    VuePerfectScrollbar,
  },
};
</script>

<style lang="scss">
.guest-note-chat-textarea {
  margin-bottom: 0 !important;
  .vs-textarea {
    min-height: 128px;
    resize: vertical !important;
  }
}
</style>
